import {
    GET_CALENDAR_PLAYERS,
    GET_CALENDAR_PLAYERS_SUCCESS,
    DELETE_USER_PLAYER,
    DELETE_USER_PLAYER_SECCESS,
    PSEUDONONYMIZE_USER_PLAYER,
    PSEUDONONYMIZE_USER_PLAYER_SECCESS,
    SET_CALENDAR_FILTER_PLAYER_SUCCESS,
    SET_CALENDAR_FILTER_PLAYER,
    SEND_CALENDAR_ADVERTISING_CLICK,
    DOWNLOAD_EXPORT_FILE,
    DOWNLOAD_EXPORT_FILE_SUCCESS,
    DELETE_CALENDAR_ALL_USER_PLAYERS,
    DELETE_CALENDAR_ALL_USER_PLAYERS_SUCCESS
} from './constants';

/**
 *
 * @param id
 * @returns {{id: *, type: string}}
 */
const getCalendarPlayers = id => ( {
    type: GET_CALENDAR_PLAYERS,
    id
} );
/**
 *
 * @param players
 * @returns {{players: *, type: string}}
 */
const getCalendarPlayersSuccess = players => ( {
    type: GET_CALENDAR_PLAYERS_SUCCESS,
    players
} );
/**
 *
 * @param calendarID
 * @param from
 * @param to
 * @param hatchId
 * @returns {{calendarID: *, hatchId: *, from: *, to: *, type: string}}
 */
const setCalendarFilter = ( calendarID, from, to, hatchId ) => ( {
    type: SET_CALENDAR_FILTER_PLAYER,
    calendarID,
    from,
    to,
    hatchId
} );
/**
 *
 * @param players
 * @returns {{players: *, type: string}}
 */
const setCalendarFilterSuccess = players => ( {
    type: SET_CALENDAR_FILTER_PLAYER_SUCCESS,
    players
} );
/**
 *
 * @param id
 * @param calendarID
 * @param from
 * @param to
 * @param hatchId
 * @returns {{calendarID: *, hatchId: *, from: *, id: *, to: *, type: string}}
 */
const deleteUserPlayer = ( id, calendarID, from, to, hatchId ) => ( {
    type: DELETE_USER_PLAYER,
    id,
    calendarID,
    from,
    to,
    hatchId
} );
/**
 *
 * @param players
 * @returns {{players: *, type: string}}
 */
const deleteUserPlayerSuccess = players => ( {
    type: DELETE_USER_PLAYER_SECCESS,
    players
} );

const pseudononymizeUserPlayer = ( player_id, calendar_id ) => ( {
    type: PSEUDONONYMIZE_USER_PLAYER,
    player_id,
    calendar_id
} );

const pseudononymizeUserPlayerSuccess = players => ( {
    type: PSEUDONONYMIZE_USER_PLAYER_SECCESS,
    players
} );

/**
 *
 * @param itemType
 * @param hatchId
 * @param link
 * @returns {{itemType: *, hatchId: *, link: string, type: string}}
 */
const playerAdvertisingClick = ( itemType, hatchId, link = 'link is not provided to parameters' ) => ( {
    type: SEND_CALENDAR_ADVERTISING_CLICK,
    itemType,
    hatchId,
    link
} );
/**
 *
 * @param calendarID
 * @returns {{calendarID: *, type: string}}
 */
const downloadExportFile = (calendarID, hatchId) => ( {
    type: DOWNLOAD_EXPORT_FILE,
    calendarID,
    hatchId
} );
/**
 *
 * @param file
 * @returns {{file: *, type: string}}
 */
const downloadExportFileSuccess = file => ( {
    type: DOWNLOAD_EXPORT_FILE_SUCCESS,
    file
} );
/**
 *
 * @param calendarID
 * @param typeData
 * @param withPlayers
 * @param resolve
 * @returns {{calendarID: *, withPlayers: *, resolve: *, type: string, typeData: *}}
 */
const deleteCalendarAllUserPlayers = ( calendarID, typeData, withPlayers, resolve ) => ( {
    type: DELETE_CALENDAR_ALL_USER_PLAYERS,
    calendarID,
    typeData,
    withPlayers,
    resolve
} );
/**
 *
 * @param players
 * @returns {{players: *, type: string}}
 */
const deleteCalendarAllUserPlayersSuccess = players => ( {
    type: DELETE_CALENDAR_ALL_USER_PLAYERS_SUCCESS,
    players
} );


export {
    getCalendarPlayers,
    getCalendarPlayersSuccess,
    deleteUserPlayer,
    deleteUserPlayerSuccess,
    pseudononymizeUserPlayer,
    pseudononymizeUserPlayerSuccess,
    setCalendarFilter,
    setCalendarFilterSuccess,
    playerAdvertisingClick,
    downloadExportFile,
    downloadExportFileSuccess,
    deleteCalendarAllUserPlayers,
    deleteCalendarAllUserPlayersSuccess
};